import React, { useState } from 'react';
import { X, Navigation, Star, Fish, Heart, Plus } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { CatchLogModal } from './CatchLogModal';
import { motion } from 'framer-motion';
export interface LocationData {
  id: string;
  name: string;
  type: 'lake' | 'river' | 'coast';
  rating: number;
  distance: string;
  fishTypes: string[];
  description: string;
  regulations: string;
  image: string;
}
interface LocationCardProps {
  location: LocationData;
  onClose: () => void;
}
export function LocationCard({
  location,
  onClose
}: LocationCardProps) {
  const {
    favorites,
    toggleFavorite
  } = useApp();
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const isFavorite = favorites.includes(location.id);
  return <>
      <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 30
    }} className="absolute bottom-20 md:bottom-auto left-4 right-4 md:left-auto md:right-4 md:top-4 md:w-80 float-card overflow-hidden z-40" data-id="element-79">
        {/* Image */}
        <div className="relative h-36" data-id="element-80">
          <img src={location.image} alt={location.name} className="w-full h-full object-cover" data-id="element-81" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-82" />

          <div className="absolute top-3 right-3 flex space-x-2" data-id="element-83">
            <button onClick={() => toggleFavorite(location.id)} className={`p-2 rounded-full backdrop-blur-sm transition-colors ${isFavorite ? 'bg-rose-500 text-white' : 'bg-white/20 text-white hover:bg-white/30'}`} data-id="element-84">
              <Heart className={`w-4 h-4 ${isFavorite ? 'fill-current' : ''}`} data-id="element-85" />
            </button>
            <button onClick={onClose} className="p-2 rounded-full bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm transition-colors" data-id="element-86">
              <X className="w-4 h-4" data-id="element-87" />
            </button>
          </div>

          <div className="absolute bottom-3 left-4" data-id="element-88">
            <p className="text-white/70 text-xs font-medium mb-0.5 capitalize" data-id="element-89">
              {location.type} · {location.distance}
            </p>
            <h3 className="text-white text-lg font-semibold" data-id="element-90">
              {location.name}
            </h3>
          </div>
        </div>

        <div className="p-4 space-y-4" data-id="element-91">
          {/* Rating & Actions */}
          <div className="flex items-center justify-between" data-id="element-92">
            <div className="flex items-center space-x-1" data-id="element-93">
              <Star className="w-4 h-4 text-amber-500 fill-amber-500" data-id="element-94" />
              <span className="font-semibold text-[var(--text-primary)]" data-id="element-95">
                {location.rating}
              </span>
              <span className="text-[var(--text-muted)] text-sm" data-id="element-96">(124)</span>
            </div>
            <div className="flex space-x-2" data-id="element-97">
              <button className="btn-accent px-4 py-2 text-sm flex items-center space-x-1.5" data-id="element-98">
                <Navigation className="w-4 h-4" data-id="element-99" />
                <span data-id="element-100">Go</span>
              </button>
              <button onClick={() => setIsLogModalOpen(true)} className="p-2 rounded-xl bg-[var(--bg-secondary)] text-[var(--text-secondary)] hover:bg-[var(--accent-light)] hover:text-[var(--accent)] transition-colors" data-id="element-101">
                <Plus className="w-5 h-5" data-id="element-102" />
              </button>
            </div>
          </div>

          {/* Fish Types */}
          <div className="flex flex-wrap gap-2" data-id="element-103">
            {location.fishTypes.map(fish => <span key={fish} className="chip-accent px-2.5 py-1 flex items-center" data-id="element-104">
                <Fish className="w-3 h-3 mr-1" data-id="element-105" />
                {fish}
              </span>)}
          </div>

          {/* Description */}
          <p className="text-sm text-[var(--text-secondary)] leading-relaxed" data-id="element-106">
            {location.description}
          </p>
        </div>
      </motion.div>

      <CatchLogModal isOpen={isLogModalOpen} onClose={() => setIsLogModalOpen(false)} locationId={location.id} locationName={location.name} data-id="element-107" />
    </>;
}